import React from 'react';
import {Col, Row, Typography} from 'antd';
import {FormattedMessage} from 'react-intl';
import {BookOutlined} from '@ant-design/icons';
import {Link, useParams} from 'react-router-dom';
import DetailWrapper from '../components/common/DetailWrapper';
import {findArticleBySlug} from '../constants/helpArticles';

const {Title, Paragraph, Text} = Typography;

const HelpArticlePage: React.FC = () => {
    const {slug} = useParams<{slug: string}>();
    const article = slug ? findArticleBySlug(slug) : undefined;

    if (!article) {
        return (
            <DetailWrapper navigateBack="/help">
                <Row className="mb-2">
                    <Col span={24}>
                        <h3>
                            <span className="text-blue mr-8"><BookOutlined/></span>
                            <FormattedMessage id="help_title"/>
                        </h3>
                    </Col>
                </Row>
                <Text type="secondary"><FormattedMessage id="help_not_found"/></Text>
                <Paragraph type="secondary" style={{marginTop: 8}}>
                    <FormattedMessage id="help_not_found_desc"/>
                </Paragraph>
                <Link to="/help"><FormattedMessage id="back_to_help"/></Link>
            </DetailWrapper>
        );
    }

    return (
        <DetailWrapper navigateBack="/help">
            <Row className="mb-2">
                <Col span={24}>
                    <Text
                        type="secondary"
                        style={{fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.5}}
                    >
                        <FormattedMessage id={`help_category_${article.category}`}/>
                    </Text>
                    <h3 style={{marginTop: 4}}>
                        <span className="text-blue mr-8"><BookOutlined/></span>
                        <FormattedMessage id={article.titleKey}/>
                    </h3>
                </Col>
            </Row>
            <Row>
                <Col xs={24} md={18} lg={14}>
                    {article.bodyBlocks.map((block, i) =>
                        block.type === 'heading' ? (
                            <Title key={i} level={5} style={{marginTop: 24, marginBottom: 8}}>
                                <FormattedMessage id={block.key}/>
                            </Title>
                        ) : (
                            <Paragraph key={i} style={{marginBottom: 12}}>
                                <FormattedMessage id={block.key}/>
                            </Paragraph>
                        )
                    )}
                </Col>
            </Row>
        </DetailWrapper>
    );
};

export default HelpArticlePage;
